import { React, useState } from 'react';
import styled, { keyframes } from 'styled-components';

import moment from 'moment';

import MemberInfo from './MemberInfo.js';
import TodayClass from './TodayClass.js';
import BoardView from './BoardView.js';
import LockerView from './LockerView.js';
import NoticeView from './NoticeView.js';
import MainPageBoardView from '../../../Board/Model/MainPageBoardView.js';


export default function MainView() {
  const [today, setToday] = useState(moment());

  return (
    <TopLevelWrapper>
      <CompoenntWrapper>
        <MemberInfo today={today} setToday={setToday}/>
        <TodayClass today={today} setToday={setToday}/>
      </CompoenntWrapper>
      {/* <BoardView /> */}
      <MainPageBoardView date={today} setDate={setToday}/>
      <LockerView />
      <NoticeView />
    </TopLevelWrapper>
  )
}

// export default MainView;

const startAnimation = keyframes`
  0% { opacity: 0; }
  50% { opacity: 0.5; } 
  100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 10px;

  align-items: center;
  vertical-align: bottom;
  
  gap: 30px;
  // gap: max(16px, 1.979166666666667vw);
  
  animation-name: ${startAnimation};
  animation-duration: 0.3s;
`;

const CompoenntWrapper = styled.div`
  display: flex;
  flex-direction: row;

  flex-wrap: wrap;

  gap: 10px;
  // gap: max(16px, 1.979166666666667vw);

  width: 1045px;
  // width: max(355px, 55.3125vw);
`;
